import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { GeoPoint } from 'firebase/firestore';

interface MapPreviewProps {
  position: GeoPoint;
}

const MapPreview: React.FC<MapPreviewProps> = ({ position }) => {
  // Use existing API key from environment
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
  
  const mapStyles = {
    height: "300px",
    width: "100%"
  };

  const defaultCenter = {
    lat: position.latitude,
    lng: position.longitude
  };

  // Only load script once at the top level
  return (
    <div className="map-container">
      {apiKey ? (
        <LoadScript googleMapsApiKey={apiKey} loadingElement={<div>Loading map...</div>}>
          <GoogleMap
            mapContainerStyle={mapStyles}
            zoom={15}
            center={defaultCenter}
          >
            <Marker position={defaultCenter} />
          </GoogleMap>
        </LoadScript>
      ) : (
        <div>Google Maps API key not found</div>
      )}
    </div>
  );
};

export default React.memo(MapPreview); // Memoize to prevent unnecessary re-renders 